import { render, staticRenderFns } from "./QuestionSection.vue?vue&type=template&id=482017a8&"
import script from "./QuestionSection.vue?vue&type=script&lang=js&"
export * from "./QuestionSection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSection.vue?vue&type=style&index=0&id=482017a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports